import { useState, useEffect } from 'react';
import { supabase } from '../../../services/supabase';
import { useAuth } from '../../../contexts/AuthContext';

export function useForumPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    fetchPosts();
  }, [user?.id]);

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const { data, error: fetchError } = await supabase
        .from('forum_posts')
        .select('id, title, content, created_at')
        .order('created_at', { ascending: false });

      if (fetchError) throw fetchError;
      setPosts(data || []);
    } catch (err) {
      console.error('Error fetching posts:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const createPost = async (title, content) => {
    try {
      const { data, error: createError } = await supabase
        .from('forum_posts')
        .insert([{
          title,
          content,
          auth_user_id: user?.id
        }])
        .select()
        .single();

      if (createError) throw createError;
      
      // Actualizar la lista de posts
      setPosts(currentPosts => [data, ...currentPosts]);
      return data;
    } catch (err) {
      console.error('Error creating post:', err);
      throw err;
    }
  };

  const deletePost = async (postId) => {
    try {
      const { error: deleteError } = await supabase
        .from('forum_posts')
        .delete()
        .eq('id', postId)
        .eq('auth_user_id', user?.id);

      if (deleteError) throw deleteError;
      
      // Actualizar la lista de posts
      setPosts(currentPosts => currentPosts.filter(post => post.id !== postId));
    } catch (err) {
      console.error('Error deleting post:', err);
      throw err;
    }
  };

  return {
    posts,
    loading,
    error,
    createPost,
    deletePost,
    refreshPosts: fetchPosts
  };
} 